import { WebPlugin } from '@capacitor/core';
export class ActionSheetWeb extends WebPlugin {
    async showActions(options) {
        return new Promise((resolve, _reject) => {
            var _a;
            let actionSheet = document.querySelector('pwa-action-sheet');
            if (!actionSheet) {
                actionSheet = document.createElement('pwa-action-sheet');
                document.body.appendChild(actionSheet);
            }
            actionSheet.header = options.title;
            actionSheet.cancelable = (_a = options.cancelable) !== null && _a !== void 0 ? _a : false;
            actionSheet.options = options.options;
            actionSheet.addEventListener('onSelection', async (e) => {
                const selection = e.detail;
                resolve({
                    index: selection,
                    canceled: false,
                });
            });
            if (options.cancelable) {
                actionSheet.addEventListener('onCanceled', async () => {
                    resolve({
                        index: -1,
                        canceled: true,
                    });
                });
            }
        });
    }
}
//# sourceMappingURL=web.js.map